getAllOption